export enum AdminDashboardTab {
	OVERVIEW = 'overview',
	DIAGNOSTICS = 'diagnostics',
	NOT_ACCEPTED_USERS = 'not-accepted-users',
}
